import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp, faGoogle } from "@fortawesome/free-brands-svg-icons";

import "./App.css";

function App() {
	return (
		<div className="fashionbazi-root">
			<nav className="fashionbazi-navbar">
				<div className="fashionbazi-logo">
					<img
						src="/favicon.ico"
						alt="FashionBazi Logo"
						className="fashionbazi-logo-img"
					/>
					FashionBazi.com
				</div>
				<div className="fashionbazi-navbar-right">
					<div className="fashionbazi-tagline">
						Checkout us Social media
					</div>
					<div className="fashionbazi-social-icons fashionbazi-social-navbar">
						<a
							href="https://wa.me/message/RS4GZMZBEXZ7B1"
							target="_blank"
							rel="noopener noreferrer"
							className="fashionbazi-social-icon fashionbazi-icon-whatsapp"
							title="WhatsApp"
							style={{
								display: "inline-flex",
								alignItems: "center",
								justifyContent: "center",
								fontSize: "2rem",
								margin: "0 0.5rem"
							}}
						>
							<FontAwesomeIcon
								icon={faWhatsapp}
								size="lg"
								color="#25D366"
							/>
						</a>
						<a
							href="https://share.google/monZ2wOgEreJPeDS0"
							target="_blank"
							rel="noopener noreferrer"
							className="fashionbazi-social-icon fashionbazi-icon-google"
							title="Google"
							style={{
								display: "inline-flex",
								alignItems: "center",
								justifyContent: "center",
								fontSize: "2rem",
								margin: "0 0.5rem"
							}}
						>
							<FontAwesomeIcon
								icon={faGoogle}
								size="lg"
								color="#4285F4"
							/>
						</a>
					</div>
				</div>
			</nav>
			<header className="fashionbazi-hero">
				<div className="fashionbazi-hero-bg" />
				<div className="fashionbazi-hero-inner">
					<h1>
						Welcome to <span>FashionBazi.com</span>
					</h1>
					<p className="fashionbazi-hero-desc">
						Your one-stop destination for all things fashion!
						<br />
						Discover the latest trends in clothing, garments,
						jewelry, and accessories for both men and women.
					</p>
				</div>
			</header>
			<main className="fashionbazi-main">
				<section id="about" className="fashionbazi-section">
					<h2>About FashionBazi</h2>
					<p>
						FashionBazi.com is dedicated to bringing you the best in
						wearable fashion. Whether you're looking for the latest
						in men's and women's clothing, stunning jewelry, or
						unique accessories, we've got you covered. Our mission
						is to make fashion accessible, exciting, and inclusive
						for everyone.
					</p>
				</section>
				<section
					id="categories"
					className="fashionbazi-section fashionbazi-categories"
				>
					<h2>Our Categories</h2>
					<div className="fashionbazi-category-list">
						<div className="fashionbazi-category-card">
							<div className="fashionbazi-category-icon fashionbazi-icon-men" />
							<h3>Men's Fashion</h3>
							<p>
								Trendy clothing, shoes, and accessories for men.
							</p>
						</div>
						<div className="fashionbazi-category-card">
							<div className="fashionbazi-category-icon fashionbazi-icon-women" />
							<h3>Women's Fashion</h3>
							<p>Elegant dresses, jewelry, handbags, and more.</p>
						</div>
						<div className="fashionbazi-category-card">
							<div className="fashionbazi-category-icon fashionbazi-icon-jewelry" />
							<h3>Jewelry</h3>
							<p>Beautiful ornaments for every occasion.</p>
						</div>
						<div className="fashionbazi-category-card">
							<div className="fashionbazi-category-icon fashionbazi-icon-accessories" />
							<h3>Accessories</h3>
							<p>
								Scarves, belts, watches, and more to complete
								your look.
							</p>
						</div>
					</div>
				</section>
				<section className="fashionbazi-section fashionbazi-contact">
					<h2>Stay Tuned!</h2>
					<p>
						We are working hard to launch our full-fledged
						e-commerce experience. Follow us for updates and get
						ready to elevate your style with FashionBazi.com!
					</p>
				</section>
			</main>
			<section className="fashionbazi-social">
				<h2>Checkout us on Social media</h2>
				<div className="fashionbazi-social-icons">
					<a
						href="https://wa.me/message/RS4GZMZBEXZ7B1"
						target="_blank"
						rel="noopener noreferrer"
						className="fashionbazi-social-icon fashionbazi-icon-whatsapp"
						title="WhatsApp"
					>
						<FontAwesomeIcon
							icon={faWhatsapp}
							size="lg"
							color="#25D366"
						/>
					</a>
					<a
						href="https://share.google/monZ2wOgEreJPeDS0"
						target="_blank"
						rel="noopener noreferrer"
						className="fashionbazi-social-icon fashionbazi-icon-google"
						title="Google"
					>
						<FontAwesomeIcon
							icon={faGoogle}
							size="lg"
							color="#4285F4"
						/>
					</a>
				</div>
			</section>
			<footer className="fashionbazi-footer">
				&copy; {new Date().getFullYear()} FashionBazi.com. All rights
				reserved.
			</footer>
		</div>
	);
}

export default App;
